const _eventList = Symbol('eventList');

function AwesomeEvent(instance: any, name: string): any {

  const clazz = instance.constructor;

  const eventList = clazz[_eventList] || [];
  clazz[_eventList] = [...eventList, name];

  //eventList.push(name);
}

function getList(clazz: any): string[] {
  return clazz.constructor[_eventList] || [];
}

export { AwesomeEvent as default, getList };
